import classnames from 'classnames';
import { useState } from 'react';
import { useDebounce } from 'react-use';
import styled, { keyframes } from 'styled-components';

type Props = {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
  width?: number;
  height?: number;
  spinning?: boolean;
};

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Star = styled.path`
  transform-origin: center;
  animation: ${spin} 2s ease-in-out infinite;
  animation-play-state: paused;
  &.spin {
    animation-play-state: running;
  }
`;

export const SpinningStarBall = ({
  className,
  color = 'white',
  style,
  width = 34,
  height = 34,
  spinning = false,
}: Props) => {
  const [isSpinning, setIsSpinning] = useState<boolean>(false);

  useDebounce(
    () => {
      setIsSpinning(false);
    },
    2000,
    [spinning]
  );

  if (!isSpinning && spinning) {
    setIsSpinning(true);
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 34"
      fill={color}
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <Star
        className={classnames(isSpinning && 'spin')}
        d="M15.4971 9.78677C16.4213 10.9386 17.6117 11.8484 18.9657 12.4378C20.3198 13.0271 21.7969 13.2784 23.2697 13.1699C23.329 13.1633 23.389 13.1738 23.4426 13.2001C23.4961 13.2264 23.5411 13.2674 23.5722 13.3184C23.6033 13.3694 23.6192 13.4281 23.618 13.4878C23.6169 13.5475 23.5987 13.6056 23.5657 13.6553C22.7562 14.8906 22.2592 16.3042 22.1174 17.7742C21.9756 19.2443 22.1933 20.7268 22.7517 22.094C22.7736 22.1481 22.7799 22.2073 22.7699 22.2648C22.76 22.3224 22.7343 22.376 22.6955 22.4197C22.6567 22.4634 22.6065 22.4954 22.5505 22.5121C22.4946 22.5288 22.4352 22.5296 22.3788 22.5143C20.9522 22.1245 19.452 22.0879 18.0081 22.4077C16.5642 22.7274 15.2199 23.3938 14.0912 24.3494C14.0461 24.3867 13.9915 24.4107 13.9336 24.4189C13.8757 24.4271 13.8167 24.4192 13.7631 24.3959C13.7095 24.3726 13.6634 24.3349 13.6298 24.287C13.5963 24.2391 13.5767 24.1828 13.5732 24.1245C13.5018 22.6499 13.073 21.2148 12.3238 19.9428C11.5746 18.6707 10.5274 17.5999 9.27239 16.8224C9.22294 16.7912 9.18312 16.7468 9.15734 16.6943C9.13157 16.6418 9.1209 16.5831 9.12642 16.5249C9.13193 16.4666 9.15338 16.411 9.18856 16.3643C9.22374 16.3176 9.27128 16.2815 9.32572 16.26C10.7078 15.7374 11.942 14.8863 12.9218 13.7802C13.9016 12.6741 14.5975 11.3462 14.9495 9.91108C14.9633 9.85443 14.9926 9.80276 15.0342 9.76186C15.0758 9.72096 15.1279 9.69245 15.1848 9.67954C15.2417 9.66663 15.301 9.66983 15.3562 9.68877C15.4114 9.70771 15.4602 9.74165 15.4971 9.78677Z"
      />
      <path d="M16.7825 3.76927C19.3993 3.76927 21.9573 4.54524 24.1331 5.99905C26.3089 7.45286 28.0047 9.51921 29.0061 11.9368C30.0075 14.3544 30.2696 17.0146 29.759 19.5811C29.2485 22.1476 27.9883 24.5051 26.138 26.3555C24.2876 28.2058 21.9302 29.4659 19.3637 29.9764C16.7972 30.487 14.1369 30.2249 11.7193 29.2235C9.30175 28.2221 7.23546 26.5263 5.78165 24.3505C4.32784 22.1748 3.55176 19.6168 3.55176 17C3.55568 13.4922 4.95088 10.1292 7.43127 7.64877C9.91165 5.16839 13.2747 3.77319 16.7825 3.76927ZM16.7825 0.217407C13.4632 0.217407 10.2185 1.20169 7.45858 3.04578C4.6987 4.88988 2.54774 7.51094 1.27751 10.5776C0.00727314 13.6442 -0.32508 17.0186 0.322479 20.2741C0.970038 23.5296 2.56842 26.5199 4.91551 28.867C7.26259 31.2141 10.2529 32.8125 13.5084 33.4601C16.7639 34.1076 20.1383 33.7753 23.2049 32.505C26.2716 31.2348 28.8927 29.0837 30.7368 26.3239C32.5808 23.564 33.5651 20.3192 33.5651 17C33.5651 12.549 31.7969 8.28025 28.6495 5.13291C25.5022 1.98557 21.2335 0.217407 16.7825 0.217407Z" />
    </svg>
  );
};
